var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 43,
    viewBox: "0 0 28 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0703 8.63965H3.56336C2.14766 8.63965 1 9.7873 1 11.203V35.8113C1 37.227 2.14766 38.3746 3.56336 38.3746H24.0703C25.486 38.3746 26.6336 37.227 26.6336 35.8113V11.203C26.6336 9.7873 25.486 8.63965 24.0703 8.63965Z",
    stroke: "#0000AC",
    strokeWidth: 1.66619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.66 33.6572V13.663C21.66 12.9269 21.0633 12.3301 20.3271 12.3301C19.5909 12.3301 18.9941 12.9269 18.9941 13.663V33.6572C18.9941 34.3934 19.5909 34.9902 20.3271 34.9902C21.0633 34.9902 21.66 34.3934 21.66 33.6572Z",
    stroke: "#0000AC",
    strokeWidth: 1.33295
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.996 33.6572V13.663C14.996 12.9269 14.3992 12.3301 13.663 12.3301C12.9269 12.3301 12.3301 12.9269 12.3301 13.663V33.6572C12.3301 34.3934 12.9269 34.9902 13.663 34.9902C14.3992 34.9902 14.996 34.3934 14.996 33.6572Z",
    stroke: "#0000AC",
    strokeWidth: 1.33295
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33094 33.6572V13.663C8.33094 12.9269 7.73415 12.3301 6.99799 12.3301C6.26182 12.3301 5.66504 12.9269 5.66504 13.663V33.6572C5.66504 34.3934 6.26182 34.9902 6.99799 34.9902C7.73415 34.9902 8.33094 34.3934 8.33094 33.6572Z",
    stroke: "#0000AC",
    strokeWidth: 1.33295
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99707 8.33076C8.99707 6.40542 8.99707 5.12211 8.99707 4.22748C8.99707 2.81177 10.1475 1.66602 11.5632 1.66602C13.3811 1.66602 14.7516 1.66602 15.7669 1.66602C17.1826 1.66602 18.3277 2.81367 18.3277 4.22938V8.33076",
    stroke: "#0000AC",
    strokeWidth: 1.66619
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36015 39.467L7.29622 39.3871C7.04319 39.0708 6.6601 38.8867 6.25505 38.8867C5.85 38.8867 5.46691 39.0708 5.21388 39.3871L5.2017 39.4024C4.83673 39.8586 4.80895 40.4985 5.13303 40.9846C5.42588 41.4239 5.94912 41.6506 6.46987 41.5638L6.56384 41.5481C6.93716 41.4859 7.26441 41.2631 7.45913 40.9386C7.73693 40.4756 7.69745 39.8887 7.36015 39.467Z",
    stroke: "#0000AC",
    strokeWidth: 1.66619
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 39.5239L22.881 39.4283C22.6108 39.0863 22.199 38.8867 21.7631 38.8867C21.3272 38.8867 20.9154 39.0863 20.6452 39.4283L20.6227 39.4569C20.2323 39.9512 20.2025 40.6401 20.5488 41.1663C20.8674 41.6503 21.4418 41.9005 22.0131 41.804L22.0831 41.7922C22.4929 41.723 22.8515 41.4768 23.0633 41.1192C23.361 40.6166 23.3186 39.9824 22.9565 39.5239Z",
    stroke: "#0000AC",
    strokeWidth: 1.66619
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.5cbed52fb07e2289cca032dcd4c1f4c0.svg";
export { ForwardRef as ReactComponent };